import Application from "../../Application";
import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class GetApplicantsAppointmentsInteractor {
  private application: Application;
  private applicantService: IApplicantService;

  constructor(application, applicantService) {
    this.application = application;
    this.applicantService = applicantService;
  }

  async execute(applicantId: number) {
    return this.applicantService.getApplicantsAppointments(applicantId);
  }
}
